// extracted by mini-css-extract-plugin
module.exports = {"popoverComponent":"ReportingActionsButton-popoverComponent-aLf8tu","actionIcon":"ReportingActionsButton-actionIcon-2ya4Nd"};